"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReadHeightReporter = (function () {
    function ReadHeightReporter(ctx, options) {
        if (options === void 0) { options = {}; }
        try {
            if (localStorage) {
                var cacheKey = 'TKD:dau-time';
                var cache_1 = parseInt(localStorage.getItem(cacheKey), 10) || 0;
                cache_1 = cache_1 + 1;
                localStorage.setItem(cacheKey, cache_1.toString());
                var reportParams_1 = options.reportParams, _a = options.beatTime, beatTime = _a === void 0 ? 5000 : _a;
                if (ctx === null || ctx === void 0 ? void 0 : ctx.reportUserAction) {
                    ctx === null || ctx === void 0 ? void 0 : ctx.reportUserAction(Object.assign({}, reportParams_1, {
                        user_action: 'tkd_dau_time',
                        time: "" + new Date().getTime(),
                        pos: cache_1,
                    }));
                    setInterval(function () {
                        ctx === null || ctx === void 0 ? void 0 : ctx.reportUserAction(Object.assign({}, reportParams_1, {
                            user_action: 'tkd_dau_time',
                            time: "" + new Date().getTime(),
                            pos: cache_1,
                        }));
                    }, beatTime);
                }
            }
        }
        catch (error) {
            console.log('ReadHeightReporter error', error);
        }
    }
    return ReadHeightReporter;
}());
exports.default = ReadHeightReporter;
//# sourceMappingURL=dau-time.plugin.js.map